import { render } from "./ProductRating.vue?vue&type=template&id=6c1c68f4"
import script from "./ProductRating.vue?vue&type=script&lang=js"
export * from "./ProductRating.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__